"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Artefact = exports.ARTEFACT_BOOLEANS = void 0;
const CallToActionArtefact_1 = require("./ArtefactItems/CallToActionArtefact");
const QuizArtefact_1 = require("./ArtefactItems/QuizArtefact");
const SharingArtefact_1 = require("./ArtefactItems/SharingArtefact");
const StoryItem_1 = require("./Story/StoryItem");
const TagArtefact_1 = require("./ArtefactItems/TagArtefact");
const uniqid = require("uniqid");
exports.ARTEFACT_BOOLEANS = [
    "isRead",
    "showReadMore"
];
const imageFields = [
    "logo", ,
    "video"
];
class Artefact {
    constructor(data) {
        this.id = null;
        this.type = null;
        this.format = null;
        this.isRead = false;
        this.showReadMore = false;
        this.openIn = null;
        this.publishedAt = null;
        this.logo = null;
        this.images = [];
        this.video = null;
        this.source = 'https://360medics.com/';
        this.author = null;
        this.title = null;
        this.subtitle = "Partenariat sponsorisé";
        this.tagline = null;
        this.description = null;
        this.footNote = "Vos données sont protégées. Aucune donnée nominative n’est partagée avec le partenaire.";
        this.richContent = null;
        this.callToAction = null;
        this.tag = null;
        this.quiz = null;
        this.story = null;
        this.sharing = null;
        this.pixelTrackingUrl = null;
        this.hydrate(data);
    }
    hydrate(data) {
        Object.keys(data).forEach(key => {
            if (Object.prototype.hasOwnProperty.call(this, key)) {
                if (key === 'type' && data[key] === 'news') {
                    this.type = 'news';
                    this.format = 'post';
                    this.openIn = "richContent" in data && data.richContent
                        ? "reader"
                        : "link";
                    this.publishedAt = data.updatedAt;
                }
                else if (key === 'tag' && data[key] !== null) {
                    this.tag = (data.format !== 'story' && data.type !== 'advert')
                        ? new TagArtefact_1.TagArtefact(data[key])
                        : null;
                }
                else if (key === 'quiz' && data[key] !== null) {
                    this.quiz = data.format === key
                        ? new QuizArtefact_1.QuizArtefact(data[key])
                        : null;
                }
                else if (key === 'story' && data[key] !== null) {
                    this.story = data.format === key
                        ? new StoryItem_1.StoryItem(data[key])
                        : null;
                }
                else if (key === 'sharing' && data[key] !== null) {
                    this.sharing = data.format !== 'story'
                        ? new SharingArtefact_1.SharingArtefact(data[key])
                        : null;
                }
                else if (exports.ARTEFACT_BOOLEANS.includes(key)) {
                    this[key] = Boolean(parseInt(data[key]));
                }
                else if (key === 'images' && data[key]) {
                    const images = typeof data[key] === "string"
                        ? JSON.parse(data[key]).map(image => `${image.split('?d=')[0]}?d=${uniqid()}`)
                        : data[key].map(image => `${image.split('?d=')[0]}?d=${uniqid()}`);
                    if (images.length) {
                        this.images = images;
                    }
                }
                else if (imageFields.includes(key) && data[key]) {
                    this[key] = typeof data[key] === 'string'
                        ? `${data[key].split('?d=')[0]}?d=${uniqid()}`
                        : data[key].map(item => `${item.split('?d=')[0]}?d=${uniqid()}`);
                }
                else {
                    this[key] = data[key];
                }
            }
            if (key === 'image' && data[key]) {
                if ("images" in data && data.images) {
                    const isImages = typeof data.images === "string"
                        ? JSON.parse(data.images).map(image => `${image.split('?d=')[0]}?d=${uniqid()}`).length
                        : data.images.map(image => `${image.split('?d=')[0]}?d=${uniqid()}`).length;
                    if (!isImages) {
                        this.images = [`${data[key].split('?d=')[0]}?d=${uniqid()}`];
                    }
                }
                else {
                    this.images = [`${data[key].split('?d=')[0]}?d=${uniqid()}`];
                }
            }
            else if (key === 'buttonLabel') {
                this.callToAction = new CallToActionArtefact_1.CallToActionArtefact({
                    text: data[key],
                    textColor: data.type === 'article' ? '#ffffff' : '#66627E',
                    backgroundColor: data.type === 'article' ? '#F30E40' : '#F5F4FC'
                });
            }
        });
    }
}
exports.Artefact = Artefact;
//# sourceMappingURL=Artefact.js.map